import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    unsubModal: false
}

const unsubModalSlice = createSlice({
    name: "unsubModalSlice",
    initialState,
    reducers: {
        setUnsubModal: (state, action) => {
            state.unsubModal = action.payload;
            return state;
        },
    }

});

export const { setUnsubModal } = unsubModalSlice.actions;
export default unsubModalSlice;